/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-empty-function */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Device } from 'src/app/models/device.model';

@Injectable()
export class DeviceService {
  private connectedDevicesUrl = '/api/devices/connectedDevices';
  private deleteDeviceUrl = '/api/devices/';

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor(private _http: HttpClient) {}

  public getAllDevices(): Observable<Device[]> {
    return this._http.get<Device[]>(this.connectedDevicesUrl);
  }

  public deleteDevice(deviceName: string): Observable<Device> {
    const deleteUrl = this.deleteDeviceUrl + deviceName;
    return this._http.delete<Device>(deleteUrl);
  }
}
